<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="checkbox-container">
    <input
      type="checkbox"
      :checked="checked"
      :disabled="isReadOnly"
      @click="(e) => $emit('click', e)" />
    <span
      class="checkmark"
      :class="{ disabled: isReadOnly, excluded: useForExclusion }"
      @click="onClick" />
  </div>
</template>

<script setup>
  const props = defineProps({
    checked: {
      type: Boolean,
      default: false,
    },
    useForExclusion: {
      type: Boolean,
      default: true,
    },
    isReadOnly: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits(['click']);

  function onClick(e) {
    if (props.isReadOnly) return;
    emits('click', e);
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .checkbox-container {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 2.2rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 2rem;
    width: 2rem;
    margin-right: 1rem;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
  }

  /* Hide the browser's default checkbox */
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 2rem;
    width: 2rem;
    background-color: #eee;
    border-radius: 0.4rem;
    box-shadow: $inner-shadow;
    transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);

    &.disabled {
      cursor: not-allowed;
    }
  }

  /* On mouse-over, add a grey background color */
  .checkbox-container:hover input ~ .checkmark {
    background-color: #ccc;
    box-shadow: $inner-shadow;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkmark {
    background-color: var(--success);

    box-shadow: 0 0.1rem 0.3rem #00000020;

    &.excluded {
      background-color: var(--error);
    }
  }

  .checkbox-container input:focus ~ .checkmark {
    box-shadow: 0 0 0.3rem var(--info);

    transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkbox-container {
    .checkmark {
      &:after {
        left: 0.8rem;
        top: 0.4rem;
        width: 0.5rem;
        height: 1rem;
        border: solid white;
        border-width: 0 0.3rem 0.3rem 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }

      &.excluded {
        &:after {
          width: 0.4rem;
          border-width: 0 0.3rem 0 0;
          -webkit-transform: rotate(90deg);
          -ms-transform: rotate(90deg);
          transform: rotate(90deg);
        }
      }
    }
  }
</style>
